import React from "react";
import { toast } from "react-toastify";

function buildToastContent(title, message) {
  if (title && message) {
    return (
      <div>
        <strong>{title}</strong>
        <div>{message}</div>
      </div>
    );
  }

  return title || message || "";
}

export function showSuccessToast(message, options = {}) {
  const { title } = options;
  toast.success(buildToastContent(title, message));
}

export function showErrorToast(message, options = {}) {
  const { title } = options;
  toast.error(buildToastContent(title, message));
}
